const reportWebVitals = onPerfEntry => {
  if (!(onPerfEntry instanceof Function)) return;

  const safePerfEntry = (metric) => {
    try {
      onPerfEntry(metric);
    } catch {
      // Performance telemetry must never break the page.
    }
  };

  import('web-vitals')
    .then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      try {
        getCLS(safePerfEntry);
        getFID(safePerfEntry);
        getFCP(safePerfEntry);
        getLCP(safePerfEntry);
        getTTFB(safePerfEntry);
      } catch {
        // Some in-app browsers expose partial native/performance bridges.
      }
    })
    .catch(() => {
      // Ignore unavailable web-vitals in constrained web views.
    });
};

export default reportWebVitals;
